import React, { useContext, useEffect, useState } from "react"
import DocumentMeta from "react-document-meta"
import { useNavigate } from "react-router-dom"
import Spinner from "../components/elements/Spinner"
import Form from "../components/Forms/Form"
import Sogehts from "../components/home/Sogehts"
import Info from "../components/Info"
import { getText } from "../components/strapi"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { getPromoLimit, getWeeklyLimit } from "../env"
import { Context } from "../store/store"
import RefundCounter from "../components/RecoundCounter"
import MobileMenu from "../components/MobileMenu"

const Home: React.FC = () => {
	const { globalState } = useContext(Context)

	// SEO Meta Tags
	const [limitReached, setLimitReached] = useState<boolean>(false)
	const [isApiError, setApiError] = useState<boolean>(false)
	const navigate = useNavigate()

	const meta = {
		title: "Volvic Gratis Testen",
		description: "Jetzt mitmachen und 1 von 30 Treatwell-Gutscheinen im Wert von 100 € gewinnen.",
		meta: {
			name: {
				robots: "noindex, nofollow",
			},
		},
	}
	async function getOrderLimits() {
		let maxLimit = await getWeeklyLimit()
		if (typeof maxLimit !== "boolean") {
			setApiError(true)
		} else {
			setLimitReached(maxLimit)
			let overallLimit = await getPromoLimit()
			if (overallLimit) {
				navigate("/promoover")
			}
		}
	}
	function scrollToHash(hash) {
		setTimeout(() => {
			try {
				const doc: any = document
				const { top } = doc.querySelector(hash).getBoundingClientRect()
				window.scrollTo({
					top: top + window.scrollY,
					left: 0,
					behavior: "smooth",
				})
			} catch (error) {}
		}, 700)
	}

	useEffect(() => {
		getOrderLimits()
		if (window.location.hash) {
			scrollToHash(window.location.hash)
		}
	}, [])
	return (
		<DocumentMeta {...meta}>
			{globalState.strapi.homepage ? (
				<>
					<div className="relative md:bg-greenBG">
						<img src="/images/hero-bubbles.jpg" alt="" className="absolute  left-[50%] top-[28%] z-10  h-auto w-[52%]" />
						<img src="/images/hero-desktop.png" alt="" className="relative z-20 w-full hidden md:block" />
						<img src="/images/bg-hero-mobile-head.png" alt="" className="relative z-20 w-full block md:hidden" />
						<img src="/images/bg-hero-mobile-body.png" alt="" className="relative z-20 w-full block md:hidden -mt-20" />
						<div className="grid grid-cols-1 items-center justify-items-center relative z-[60] -mt-16 md:-mt-[12rem] md:mb-44">
							<a
								href="#form"
								className=" tracking-wide mb-6 block w-[100%] rounded-full bg-[#FFDD08]   max-w-[227px] md:max-w-full p-4 font-Veener text-[29px]  sm:text-[42px] leading-none uppercase text-[#007331] sm:w-[auto]  lg:inline-block lg:py-2 lg:px-6"
								style={{
									boxShadow: "0px 2.21px 16.575px 0px rgba(0, 0, 0, 0.40)",
								}}
							>
								jetzt mitmachen
							</a>
						</div>
						<div className="bg-greenBG -mt-20">
							<Sogehts />

							{!limitReached && (
								<div className="relative z-10 ">
									<h3 className="mb-6 text-white">{getText(globalState.strapi.homepage.refundsLeftHeadline, "refundsLeftHeadline")}</h3>
									<RefundCounter />
								</div>
							)}
						</div>
					</div>
					<MobileMenu />
					<img src="/images/divider.png" alt="" className="w-full scale-105" />

					{isApiError ? (
						<>
							<div className="mt-12 lg:mt-24">
								<h2>
									Leider ist ein Fehler aufgetreten. <br />
									Bitte versuche es später erneut.
								</h2>
							</div>
						</>
					) : !limitReached ? (
						<>
							<Form />
							<Info />
						</>
					) : (
						<>
							<div className="mt-12 lg:mt-24">
								<h2 className=" mb-12 text-center font-Veener text-[28px] uppercase text-red lg:text-[58px]">
									Diese Woche sind leider keine Erstattungen mehr möglich. <br />
									Bitte versuche es ab nächsten Montag erneut.
								</h2>
							</div>
						</>
					)}
				</>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
		</DocumentMeta>
	)
}
export default Home
